module.exports = __webpack_public_path__ + "bd78bf7e5cb30c04fe7564228e585637.png";